import { computed, ref, watch } from "vue";

/**
 * Need double observer couse in site the sticky end when we go out of the container box
 * @param {ref} target 
 * @returns 
 */
export function useSticky(target){
	if(!target) target = ref();

	const threshold0Intersecting = ref(true);
	const threshold1Intersecting = ref(true);
	const sticking = computed(() => threshold0Intersecting.value && !threshold1Intersecting.value);

	const observerThreshold0 = new IntersectionObserver(([entry]) => {
		threshold0Intersecting.value = entry.isIntersecting;
	});

	const observerThreshold1 = new IntersectionObserver(([entry]) => {
		threshold1Intersecting.value = entry.isIntersecting;
	}, {threshold: 1});

	watch(target, (element) => {
		observerThreshold0.disconnect();
		observerThreshold1.disconnect();
		if(element){
			observerThreshold0.observe(element);
			observerThreshold1.observe(element);
		}
	});

	if(target.value){
		observerThreshold0.observe(target.value);
		observerThreshold1.observe(target.value);
	}

	return {
		target,
		sticking
	};
}